import styled from 'styled-components';
import { buttonReset, token } from './renewalStyles';

/**
 * 프로젝트 의뢰 / 입사지원 폼이 공유하는 스타일.
 * 두 폼은 필드 구성만 다르고 시각 언어는 동일합니다.
 */

export const FormRoot = styled.form`
  display: flex;
  flex-direction: column;
  gap: 28px;
`;

export const Required = styled.span`
  color: ${token.primary};
`;

export const FieldTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 14px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const InputLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const HelpText = styled.p`
  margin: 0 0 12px;
  font-size: 13px;
  line-height: 1.7;
  color: ${token.faint};
`;

export const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Chip = styled.button`
  ${buttonReset};
  padding: 11px 20px;
  min-height: 44px;
  font-size: 14px;
  font-weight: ${({ $on }) => ($on ? 700 : 600)};
  border: 1px solid ${({ $on }) => ($on ? token.primary : token.inputBorder)};
  background: ${({ $on }) => ($on ? token.primary : '#fff')};
  color: ${({ $on }) => ($on ? '#fff' : token.inputText)};
  transition: border-color 0.2s, color 0.2s, background 0.2s;

  &:hover {
    border-color: ${token.primary};
    color: ${({ $on }) => ($on ? '#fff' : token.primary)};
  }
`;

const fieldBase = `
  width: 100%;
  background: #fff;
  border: 1px solid ${token.inputBorder};
  color: ${token.ink};
  font-size: 15px;
  font-family: inherit;
`;

export const TextArea = styled.textarea`
  ${fieldBase};
  padding: 14px 16px;
  resize: vertical;
  line-height: 1.7;

  &::placeholder {
    color: #b0b6bf;
  }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(220px, 100%), 1fr));
  gap: 20px;
`;

export const TextField = styled.input`
  ${fieldBase};
  padding: 13px 16px;
  min-height: 44px;

  &::placeholder {
    color: #b0b6bf;
  }
`;

export const SelectField = styled.select`
  ${fieldBase};
  padding: 13px 16px;
  min-height: 44px;
`;

export const FileButton = styled.label`
  display: inline-block;
  background: #000;
  color: #fff;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
`;

export const HiddenFileInput = styled.input`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;

export const FileHelp = styled.p`
  margin: 10px 0 0;
  font-size: 13px;
  line-height: 1.7;
  color: ${token.faint};
`;

export const FileMessage = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: ${token.primary};
`;

export const AgreeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AgreeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const AgreeLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: ${token.inputText};
  cursor: pointer;

  input {
    margin-top: 3px;
    width: 18px;
    height: 18px;
    accent-color: ${token.primary};
    cursor: pointer;
  }
`;

export const ViewButton = styled.button`
  ${buttonReset};
  border-bottom: 1px solid ${token.faint};
  color: ${token.faint};
  font-size: 13px;
  padding: 0 0 2px;
`;

export const SubmitRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

export const SubmitMessage = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${token.primary};
`;

export const SubmitButton = styled.button`
  ${buttonReset};
  background: ${token.primary};
  color: #fff;
  padding: 16px 44px;
  min-height: 44px;
  font-size: 17px;
  font-weight: 800;
  transition: background 0.2s;

  &:hover:not(:disabled) {
    background: ${token.primaryHover};
  }

  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;
